if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.closest(".m-testimonials");

      let containerType, autoplay;

      if (this.dataset.design) {
        this.design = this.dataset.design;
      }

      if (this.dataset.container) {
        containerType = this.dataset.container;
      }

      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === "true";
      }

      const slidesDesktop = Math.max(
        1,
        parseFloat(this.dataset.slidesDesktop || "3")
      );
      const slidesMobile = Math.max(
        1,
        parseFloat(this.dataset.slidesMobile || "1")
      );
      const gapDesktop = Math.max(
        0,
        parseFloat(this.dataset.gapDesktop || "24")
      );
      const gapMobile = Math.max(
        0,
        parseFloat(this.dataset.gapMobile || "12")
      );
      const totalSlides = Math.max(
        0,
        parseInt(this.dataset.total || "0", 10)
      );

      if (!this.design) {
        console.warn("Failed to init Testimonials: design not found!!");
        return;
      }

      this.sliderContainer = this.querySelector(".swiper-container");

      if (!this.sliderContainer) {
        this.classList.add("opacity-100");
        return;
      }

      const customPagination = this.container?.querySelector(
        "[data-testimonials-pagination]"
      );

      this.defaultSettings = {
        pagination: customPagination
          ? {
              el: customPagination,
              clickable: true,
              type: "bullets",
            }
          : {
              el: this.container?.querySelector(".swiper-pagination"),
              clickable: true,
            },

        navigation: customPagination
          ? false
          : {
              nextEl: this.container?.querySelector(
                ".m-slider-controls__button-next"
              ),
              prevEl: this.container?.querySelector(
                ".m-slider-controls__button-prev"
              ),
            },

        autoplay: autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
            }
          : false,

        loop: true,
        slidesPerView: 1,
      };

      this.settings = {};
      let gutter = 400;

      switch (this.design) {
        case "testimonials-1": {
          const desktopGroup = Math.max(1, Math.floor(slidesDesktop));

          this.settings = {
            centeredSlides: false,
            slidesPerView: slidesMobile,
            slidesPerGroup: 1,
            spaceBetween: gapMobile,
            speed: 520,
            slideToClickedSlide: false,
            loop: false,
            rewind: true,
            watchOverflow: true,
            grabCursor: true,

            pagination: customPagination
              ? {
                  el: customPagination,
                  clickable: true,
                  type: "bullets",
                }
              : false,

            navigation: false,

            autoplay:
              autoplay && totalSlides > 1
                ? {
                    delay: 5000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }
                : false,

            breakpoints: {
              768: {
                slidesPerView: slidesDesktop,
                slidesPerGroup: desktopGroup,
                spaceBetween: gapDesktop,
                speed: 620,
              },
            },
          };
          break;
        }

        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
            },
          };
          break;

        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: {
                slidesPerView: containerType === "w-full" ? 3 : 2,
              },
            },
          };
          break;

        case "testimonials-4":
          if (containerType === "container-fluid") gutter = 200;
          if (containerType === "container") gutter = 150;

          this.settings = {
            slidesPerView: 1,
            centeredSlides: true,
            slideToClickedSlide: true,

            breakpoints: {
              768: {
                spaceBetween: parseInt(gutter / 4, 10),
                slidesPerView: 3,
              },
              992: {
                spaceBetween: gutter / 2,
                slidesPerView: 3,
              },
              1920: {
                spaceBetween: gutter,
                slidesPerView: 3,
              },
            },
          };
          break;

        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            loop: true,

            pagination:
              this.dataset.paginationType === "fraction"
                ? {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                  },

            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1366: {
                slidesPerView: containerType === "container" ? 2 : 3,
              },
              1600: {
                slidesPerView:
                  containerType === "container-fluid" ? 3 : 4,
              },
            },
          };
          break;

        case "testimonials-7":
          this.settings = {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: true,

            pagination:
              this.dataset.paginationType === "fraction"
                ? {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
          };
          break;

        case "testimonials-8":
          this.settings = {
            fade: {
              crossFade: true,
            },

            pagination:
              this.dataset.paginationType === "fraction"
                ? {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container?.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
          };
          break;

        case "testimonials-5":
          this.settings = {
            fade: {
              crossFade: true,
            },
          };
          break;
      }

      const images = this.querySelector(".m-tabs");

      if (images) {
        const interval = setInterval(() => {
          if (
            typeof window.MinimogTheme !== "undefined" &&
            window.MinimogTheme.Tabs
          ) {
            clearInterval(interval);
            this.imagesTab = new window.MinimogTheme.Tabs(images);
          }
        }, 50);
      }

      this.initSlider();
    }

    initSlider() {
      if (
        typeof window.MinimogLibs === "undefined" ||
        !window.MinimogLibs.Swiper
      ) {
        console.warn("Failed to init Testimonials: Swiper not found.");
        this.classList.add("opacity-100");
        return;
      }

      this.slider = new window.MinimogLibs.Swiper(
        this.sliderContainer,
        {
          ...this.defaultSettings,
          ...this.settings,

          on: {
            init: () => {
              setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
              }, 100);
            },
          },
        }
      );

      if (this.design === "testimonials-4") {
        this.slider.on("activeIndexChange", (swiper) => {
          const { realIndex } = swiper;
          const indexElement = this.querySelector(
            ".m-testimonial-index"
          );

          if (indexElement) {
            indexElement.innerHTML =
              parseInt(realIndex, 10) + 1;
          }
        });
      }

      if (
        this.design === "testimonials-5" ||
        this.design === "testimonials-8"
      ) {
        this.slider.on("slideChange", (swiper) => {
          const { realIndex } = swiper;

          if (
            this.imagesTab &&
            typeof this.imagesTab.setActiveTab === "function"
          ) {
            this.imagesTab.setActiveTab(realIndex);
          }
        });
      }

      document.addEventListener(
        "shopify:block:select",
        (event) => this.onBlockSelect(event)
      );
    }

    onBlockSelect(event) {
      const block = event.target;
      const index = Number(block.dataset.index);

      if (!this.slider || Number.isNaN(index)) return;

      if (this.design === "testimonials-1") {
        this.slider.slideTo(index);
      } else {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}

/* =========================================================
   Customer review popup
   Event delegation makes this work even when Shopify reloads
   the section dynamically in the Theme Editor.
========================================================= */
(() => {
  if (window.__mTestimonialsReviewPopupReady) return;
  window.__mTestimonialsReviewPopupReady = true;

  const getSection = (element) =>
    element?.closest?.(".m-testimonials");

  const getStorageKey = (section) => {
    const sectionId =
      section?.dataset?.sectionId ||
      section?.id ||
      "testimonials";

    return `shopify_customer_reviews_${sectionId}`;
  };

  const escapeHTML = (value) => {
    const element = document.createElement("div");
    element.textContent = String(value ?? "");
    return element.innerHTML;
  };

  const getSavedReviews = (section) => {
    try {
      const reviews = JSON.parse(
        localStorage.getItem(getStorageKey(section)) || "[]"
      );

      return Array.isArray(reviews) ? reviews : [];
    } catch (error) {
      return [];
    }
  };

  const saveReviews = (section, reviews) => {
    try {
      localStorage.setItem(
        getStorageKey(section),
        JSON.stringify(reviews.slice(0, 20))
      );
    } catch (error) {
      console.warn("Could not save customer review locally.", error);
    }
  };

  const createReviewCard = (review) => {
    const card = document.createElement("article");
    card.className = "m-customer-review__card";

    const rating = Math.max(
      1,
      Math.min(5, Number(review.rating) || 5)
    );

    const stars =
      "★".repeat(rating) +
      "☆".repeat(5 - rating);

    card.innerHTML = `
      <div class="m-customer-review__card-top">
        <strong class="m-customer-review__card-name">
          ${escapeHTML(review.name)}
        </strong>

        <span class="m-customer-review__card-date">
          ${escapeHTML(review.date || "Just now")}
        </span>
      </div>

      <div
        class="m-customer-review__card-stars"
        aria-label="${rating} out of 5 stars"
      >
        ${stars}
      </div>

      <p class="m-customer-review__card-text">
        ${escapeHTML(review.message)}
      </p>

      <span class="m-customer-review__verified">
        Customer Review
      </span>
    `;

    return card;
  };

  const renderSavedReviews = (section) => {
    if (!section) return;

    const container = section.querySelector(
      "[data-saved-reviews]"
    );

    if (!container) return;

    container.innerHTML = "";

    getSavedReviews(section).forEach((review) => {
      container.appendChild(
        createReviewCard(review)
      );
    });
  };

  const openPopup = (section) => {
    if (!section) return;

    const modal = section.querySelector(
      "[data-review-panel]"
    );
    const toggle = section.querySelector(
      "[data-review-toggle]"
    );

    if (!modal) {
      console.warn("Review popup modal was not found.");
      return;
    }

    modal.hidden = false;
    modal.removeAttribute("hidden");

    if (toggle) {
      toggle.setAttribute("aria-expanded", "true");
    }

    document.documentElement.style.overflow = "hidden";

    window.setTimeout(() => {
      modal
        .querySelector(
          'input:not([type="hidden"]), textarea'
        )
        ?.focus();
    }, 50);
  };

  const closePopup = (section) => {
    if (!section) return;

    const modal = section.querySelector(
      "[data-review-panel]"
    );
    const toggle = section.querySelector(
      "[data-review-toggle]"
    );

    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute("hidden", "");

    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
    }

    document.documentElement.style.overflow = "";
  };

  document.addEventListener(
    "click",
    (event) => {
      const openButton = event.target.closest(
        "[data-review-toggle]"
      );

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();

        openPopup(getSection(openButton));
        return;
      }

      const closeButton = event.target.closest(
        "[data-review-close]"
      );

      if (closeButton) {
        event.preventDefault();

        closePopup(getSection(closeButton));
      }
    },
    true
  );

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    document
      .querySelectorAll(
        ".m-customer-review__modal:not([hidden])"
      )
      .forEach((modal) => {
        closePopup(getSection(modal));
      });
  });

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target.closest(
        ".m-customer-review__form"
      );

      if (!form) return;

      event.preventDefault();

      if (!form.reportValidity()) return;

      const section = getSection(form);
      const status = form.querySelector(
        "[data-review-status]"
      );
      const submitButton = form.querySelector(
        "[data-review-submit]"
      );
      const savedContainer = section?.querySelector(
        "[data-saved-reviews]"
      );

      const name = form
        .querySelector("[data-review-name]")
        ?.value.trim();

      const email = form
        .querySelector("[data-review-email]")
        ?.value.trim();

      const message = form
        .querySelector("[data-review-message]")
        ?.value.trim();

      const ratingInput = form.querySelector(
        'input[name="contact[Rating]"]:checked'
      );

      const rating = Number(
        ratingInput?.value || 0
      );

      if (!name || !email || !message || !rating) {
        if (status) {
          status.className =
            "m-customer-review__message is-error";
          status.textContent =
            "Please complete all fields.";
        }

        return;
      }

      const review = {
        name,
        rating,
        message,
        date: "Just now",
        createdAt: new Date().toISOString(),
      };

      const reviews = getSavedReviews(section);
      reviews.unshift(review);
      saveReviews(section, reviews);

      if (savedContainer) {
        savedContainer.prepend(
          createReviewCard(review)
        );
      }

      if (status) {
        status.className =
          "m-customer-review__message is-success";
        status.textContent =
          "Thank you! Your review has been added.";
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Submitted";
      }

      try {
        await fetch(form.action, {
          method: "POST",
          body: new FormData(form),
          headers: {
            Accept: "text/html",
          },
        });
      } catch (error) {
        console.warn(
          "The review appeared locally, but email delivery failed.",
          error
        );
      }

      form.reset();

      window.setTimeout(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent =
            "Submit Review";
        }

        if (status) {
          status.textContent = "";
        }

        closePopup(section);
      }, 1200);
    },
    true
  );

  const renderAllSections = () => {
    document
      .querySelectorAll(".m-testimonials")
      .forEach(renderSavedReviews);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      renderAllSections,
      { once: true }
    );
  } else {
    renderAllSections();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section = event.target.matches?.(
        ".m-testimonials"
      )
        ? event.target
        : event.target.querySelector?.(
            ".m-testimonials"
          );

      renderSavedReviews(section);
    }
  );
})();

